// extracted by mini-css-extract-plugin
export default {"analystName":"UserBadge_analystName__sg+fu"};